"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PasswordToggle = void 0;

var _tslib = require("tslib");

var _react = _interopRequireDefault(require("react"));

var _reactFeather = require("react-feather");

var _Box = _interopRequireDefault(require("../../../../Layout/Box"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PasswordHiddenIcon = function PasswordHiddenIcon(_a) {
  var _b = _a.variant,
      variant = _b === void 0 ? 'eye' : _b,
      hiddenIconProps = (0, _tslib.__rest)(_a, ["variant"]);
  return _react.default.createElement(_reactFeather.Eye, (0, _tslib.__assign)({
    sx: {
      variant: "forms.password." + variant
    }
  }, hiddenIconProps));
};

var PasswordVisibleIcon = function PasswordVisibleIcon(_a) {
  var _b = _a.variant,
      variant = _b === void 0 ? 'eyeOff' : _b,
      visibleIconProps = (0, _tslib.__rest)(_a, ["variant"]);
  return _react.default.createElement(_reactFeather.EyeOff, (0, _tslib.__assign)({
    sx: {
      variant: "forms.password." + variant
    }
  }, visibleIconProps));
};

var PasswordToggle = function PasswordToggle(_a) {
  var _b = _a.variant,
      variant = _b === void 0 ? 'primary' : _b,
      passwordProps = (0, _tslib.__rest)(_a, ["variant"]);
  return _react.default.createElement(_Box.default, (0, _tslib.__assign)({
    as: "button",
    sx: {
      position: 'absolute',
      cursor: 'pointer',
      top: '50%',
      transform: 'translate(0, -50%)',
      right: '12px',
      background: 'transparent',
      border: 'none',
      color: 'muted',
      '&:hover': {
        color: 'muted',
        background: 'transparent'
      },
      ':focus': {
        outline: '1px dotted',
        outlineColor: 'muted',
        outlineOffset: '2px'
      },
      variant: "forms." + variant + ".password.toggle"
    },
    variant: variant
  }, passwordProps));
};

exports.PasswordToggle = PasswordToggle;
PasswordToggle.Visible = PasswordVisibleIcon;
PasswordToggle.Hidden = PasswordHiddenIcon;